import { SidebarProvider } from "@/components/ui/sidebar"
import { BackofficeSidebar } from "../Organisms/BackofficeSidebar"
import { useIsMobile } from "@/hooks/use-mobile"
import { useAuth } from "@/modules/Auth/context/AuthContext"
import { AppBar } from "../Organisms/AppBar"
import { MobileHeader } from "../Organisms/MobileHeader"
import { ChatProvider, useChat } from "@/modules/Chat/context/ChatContext"
import { ChatWidget } from "@/modules/Chat/components/ChatWidget"
import { Outlet, useLocation } from "react-router-dom"
import gaiaLogo from "@/assets/gaia-logo.png"
import { FaceCaptureModal } from "../Molecules/FaceCaptureModal/FaceCaptureModal"
import { useEffect, useState } from "react"
import { getFaceImage } from "@/modules/Users/service/UsersService"
import { ImpersonationBanner } from "@/modules/Auth/components/ImpersonationBanner"

function BackofficeContent() {
  const { user } = useAuth()
  const isMobile = useIsMobile()
  const { pathname } = useLocation()
  const { openChat } = useChat()
  const [isFaceCaptureModalOpen, setIsFaceCaptureModalOpen] = useState(false)

  useEffect(() => {
    getFaceImage()
      .then(({ data }) => {
        if (!data.data.data.hasPhoto && (user?.pesTipo === 3 || user?.pesTipo === 5)) {
          setIsFaceCaptureModalOpen(true)
        }
      })
      .catch((error) => {
        if (user?.pesTipo === 3 || user?.pesTipo === 5) {
          setIsFaceCaptureModalOpen(true)
        }
        console.error(error.response.data.message)
      })
  }, [])

  return (
    <SidebarProvider>
      {user && (
        <div className="min-h-screen w-full bg-background">
          <ImpersonationBanner />
          {/* {user.pesTipo === 3 && <ChatWidget />} */}

          {isMobile ? (
            <>
              <BackofficeSidebar
                userName={user.pesNome}
                userRole={user.pesTipo_desc}
              />

              <MobileHeader />

              <main className="mb-24 flex h-full w-full flex-col overflow-x-hidden">
                <Outlet />
                <FaceCaptureModal
                  isOpen={isFaceCaptureModalOpen}
                  onOpenChange={setIsFaceCaptureModalOpen}
                />
              </main>

              {pathname.includes("chat") ? null : <AppBar />}
            </>
          ) : (
            <div className="flex">
              <BackofficeSidebar
                userName={user.pesNome}
                userRole={user.empNome}
              />
              <main className="flex-1 overflow-x-auto">
                {/* {user.pesTipo === 3 && (
                  <button
                    onClick={openChat}
                    className="fixed bottom-10 right-10 z-50 flex size-16 items-center justify-center rounded-sm border border-orange-500 bg-black transition-transform hover:scale-110"
                  >
                    <img
                      src={gaiaLogo}
                      alt=""
                      width="40"
                    />
                  </button>
                )} */}
                <Outlet />
                <FaceCaptureModal
                  isOpen={isFaceCaptureModalOpen}
                  onOpenChange={setIsFaceCaptureModalOpen}
                />
              </main>
            </div>
          )}
        </div>
      )}
    </SidebarProvider>
  )
}

export function BackofficeLayout() {
  return (
    <ChatProvider>
      <BackofficeContent />
    </ChatProvider>
  )
}
